import { Routes } from "../../../routes";

class AuthHelper {
  pagesWithoutAuth = [Routes.freya];
  pagesWithHeader = [`${Routes.freya}${Routes.printSettings}`];

  isWithoutAuth() {
    return Boolean(
      this.pagesWithoutAuth.find(location => window.location.href.includes(location)) || new URL(window.location.href).pathname === "/"
    );
  }

  isFreya() {
    return Boolean(
      window.location.href.includes(Routes.freya)
    );
  }

  isWithHeader(location: string) {
    return Boolean(this.pagesWithHeader.find(loc => location.includes(loc)));
  }
}

export default new AuthHelper();
